import classnames from 'classnames';
import styles from "./StickyBar.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var StickyBar = function StickyBar(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.stickyBar, styles[position], className),
    "data-e2e-name": "stickybar",
    children: children
  });
};